import Axios from "axios";

export default {
    async getRules(itemId) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}inventory/rules/${itemId}`
        );
        if (res && res.data && res.data.response) {
            return res.data.response;
        } else {
            return [];
        }
    },
    async getPatientAgeWeight(patientId) {
        let res = await Axios.get(
            `${process.env.BARRAMUNDI}patient/${patientId}/age-in-days-weight-in-grams`
        );
        return res?.data || null;
    },
    async saveRule(itemId, params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}inventory/rules/${itemId}`,
            params
        );

        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    deleteRule(itemId, params) {
        return Axios.delete(
            `${process.env.BARRAMUNDI}inventory/rules/${itemId}`,
            { params }
        ).then(response => response.data);
    }
};
